import Swiper, {Navigation} from 'swiper';

export default function swiper_ilo_design() {
	new Swiper('.swiper_ilo_design', {
		modules: [Navigation],
		speed: 400,
		spaceBetween: 25,
		slidesPerView: 'auto',
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});
}



// WEBPACK FOOTER //
// ./scripts/swiper_ilo_design.js